import styled from "styled-components";

export const Container = styled.div<{ isTitle: boolean; }>`
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 16px;
    height : ${({ isTitle }) => (isTitle ? '500px' : '200px')};
    margin-bottom: 16px;
`;

export const Text = styled.div`
    font-size: 16px;
    color: #2b2828;
    padding: 0 8px;
    margin-bottom: 8px;
`;
